module.exports = __webpack_public_path__ + "static/media/youtube_logo.a28b4fa7.png";